function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

import React from "react";
import PropTypes from "prop-types";
import { jsx as ___EmotionJSX } from "@emotion/core";

var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "13o7eu2",
  styles: "display:block;"
} : {
  name: "13o7eu2",
  styles: "display:block;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9pY29ucy90aWNrLXNtYWxsLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU1NIiwiZmlsZSI6Ii4uLy4uLy4uL3NyYy9pY29ucy90aWNrLXNtYWxsLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gXCJyZWFjdFwiO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tIFwicHJvcC10eXBlc1wiO1xuXG5mdW5jdGlvbiBUaWNrU21hbGwoeyBzaXplLCBwcmltYXJ5Q29sb3IsIHRlc3RJZCB9KSB7XG4gIHJldHVybiAoXG4gICAgPHN2Z1xuICAgICAgY3NzPXt7XG4gICAgICAgIGRpc3BsYXk6IFwiYmxvY2tcIixcbiAgICAgIH19XG4gICAgICB3aWR0aD17c2l6ZX1cbiAgICAgIGhlaWdodD17c2l6ZX1cbiAgICAgIHZpZXdCb3g9XCIwIDAgMzIgMzJcIlxuICAgICAgZm9jdXNhYmxlPVwiZmFsc2VcIlxuICAgICAgcm9sZT1cImltZ1wiXG4gICAgICBhcmlhLWxhYmVsPVwiVGljayBzbWFsbFwiXG4gICAgICBkYXRhLXRlc3RpZD17dGVzdElkfVxuICAgID5cbiAgICAgIDxwYXRoXG4gICAgICAgIGQ9XCJNMTMuNzQ5IDE4LjEyOWw1Ljk4NS02Ljc4N2ExIDEgMCAwMTEuNTA1IDEuMzE3bC02Ljc0NyA3LjY1OGExIDEgMCAwMS0xLjUxNC0uMDFsLTEuNzQtMi4xNzhhMSAxIDAgMTExLjUyMy0xLjI5OGwuOTg4IDEuMjk4elwiXG4gICAgICAgIGZpbGw9e3ByaW1hcnlDb2xvcn1cbiAgICAgIC8+XG4gICAgPC9zdmc+XG4gICk7XG59XG5cblRpY2tTbWFsbC5wcm9wVHlwZXMgPSB7XG4gIHNpemU6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgcHJpbWFyeUNvbG9yOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIHRlc3RJZDogUHJvcFR5cGVzLnN0cmluZyxcbn07XG5cbmV4cG9ydCBkZWZhdWx0IFRpY2tTbWFsbDtcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

function TickSmall(_ref) {
  var size = _ref.size,
      primaryColor = _ref.primaryColor,
      testId = _ref.testId;
  return ___EmotionJSX("svg", {
    css: _ref2,
    width: size,
    height: size,
    viewBox: "0 0 32 32",
    focusable: "false",
    role: "img",
    "aria-label": "Tick small",
    "data-testid": testId
  }, ___EmotionJSX("path", {
    d: "M13.749 18.129l5.985-6.787a1 1 0 011.505 1.317l-6.747 7.658a1 1 0 01-1.514-.01l-1.74-2.178a1 1 0 111.523-1.298l.988 1.298z",
    fill: primaryColor
  }));
}

TickSmall.propTypes = {
  size: PropTypes.string.isRequired,
  primaryColor: PropTypes.string.isRequired,
  testId: PropTypes.string
};
export default TickSmall;